import { IOfferCardProps } from 'shared/components/OfferCard';
import { EMappedTypeOffer } from 'shared/constants/mapOfferTypes';
import { TMapOffersResult } from 'shared/types/common/offer';

export const flattenOffersList = (offersList: TMapOffersResult): IOfferCardProps[] => {
  return offersList.flatMap(({ type, content }) => {
    if (type === EMappedTypeOffer.MULTI) {
      return content;
    }

    return [content];
  });
};

export const getOffersCount = (offersList: TMapOffersResult): number => {
  return flattenOffersList(offersList).length;
};
